import { useState } from 'react';
// import Subscribe from '../Subscribe';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFWatchVideo from '@/components/UI/svg/delta2max/EFWatchVideo';
import { youtubeMap } from '@/constants/delta2max';

export default function A() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const { locale } = useRouter();

    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: 'Product Detail_1',
            __btn_id1: css.d2xDetailA,
            __btn_id2: t('sec1_btn'),
        });
    };

    return (
        <div className={`d2x-detail-A ${css.d2xDetailA} GtmModuleData-section`} data-section-id={css.d2xDetailA} data-section-title={t('sec1_title')}>
            <p className="top-tips">{t('sec1_slogan')}</p>
            <NextImage
                webpSrc={require('@publicLocal/delta2max/detail/h5/us/kv.webp')}
                src={require('@publicLocal/delta2max/detail/h5/us/kv.png')}
                alt={t('sec1_title')}
                aria-label={t('sec1_title')}
            />
            <div className="reddot">
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/reddot-h5.webp')}
                    src={require('@publicLocal/delta2max/reddot-h5.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>

            <div className="text-wrapper">
                <p className="desc">{t('sec1_desc')}</p>
                <p className="title">{t('sec1_title')}</p>
                <div className="video-btn GtmModuleData-btn-text" onClick={() => playerVideo()}>
                    <p>{t('sec1_btn')}</p>
                    <div className="video-icon">
                        <EFWatchVideo />
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
